<template>
    <div class="no_distribution pt-3">
        <b-container fluid>
            <div class="alert alert-danger text-center">
                {{ $route.params.message || 'Não foi encontrada distribuição para o hotel selecionado.' }}
            </div>
        </b-container>
    </div>
</template>

<script>
export default {
  name: 'no_distribution',
}
</script>